import { isNumber } from 'portaltransparencia-common/libs/NumberUtils.js';
import { somenteNumeros } from 'portaltransparencia-common/libs/StringUtils.js';

export function numeroPlaca(placa) {
  if (placa) {
    return somenteNumeros(placa);
  } else {
    return '';
  }
}

export function letraPlaca(placa) {
  if (placa) {
    let letra = '';
    placa
      .trim()
      .replace('-', '')
      .replace(' ', '')
      .split('')
      .filter(i => i != ' ' && i != '-' && !isNumber(i))
      .map(i => (letra += i));

    return letra;
  } else {
    return '';
  }
}
